import React, { FC } from 'react';
import { Box } from '@wix/design-system';
import s from './Checkout.scss';
import { Checkout as CheckoutPage } from '@wix/gg-components';
import { ARTIFACT_ID } from '../../application-constants';
import { useTranslation } from '@wix/wix-i18n-config';
import { setMetasiteError } from '../../context/errors';
import { useMsIdAtomValue } from '../../context/dsUserInsights';

export const Checkout: FC = () => {
  const { t } = useTranslation();
  const msId = useMsIdAtomValue();

  if (!msId) {
    setMetasiteError(true);
    return null;
  }

  return (
    <Box className={s.wrap} height="100%">
      <Box className={s.card} height="100%" width="100%">
        <CheckoutPage
          msId={msId}
          artifactId={ARTIFACT_ID}
          title={t('premium.checkout.header.title')}
          subtitle={t('premium.checkout.header.subtitle')}
        />
      </Box>
    </Box>
  );
};
